import { actionTypes } from '../../constants';
import { fromJS } from 'immutable';
import { getOverdraftEnabledFlag } from '../../../src/utils/AccountDetailsBuilder';

const {
  GET_ARRANGED_OVERDRAFT_ALERT_SUCCESS,
  GET_ARRANGED_OVERDRAFT_ALERT_FAILURE,
  UPDATE_ARRANGED_OVERDRAFT_ALERT_SUCCESS,
  UPDATE_ARRANGED_OVERDRAFT_ALERT_FAILURE,
  CLOSE_MODAL,
} = actionTypes;

export const initialState = fromJS({
  arrangedOverdraftAlert: {},
  updateOverdraftError: false,
  updateArrangedOverdraftAlertError: undefined,
});

const arrangedOverdraft = (state = initialState, action) => {
  switch (action.type) {
    case GET_ARRANGED_OVERDRAFT_ALERT_SUCCESS:
      return state.set('arrangedOverdraftAlert', fromJS(getOverdraftEnabledFlag(action.payload)));

    case GET_ARRANGED_OVERDRAFT_ALERT_FAILURE:
      return state.set('arrangedOverdraftAlertError', fromJS(action.error));

    case UPDATE_ARRANGED_OVERDRAFT_ALERT_SUCCESS:
      return state.set('arrangedOverdraftAlert', fromJS(getOverdraftEnabledFlag(action.payload)));

    case UPDATE_ARRANGED_OVERDRAFT_ALERT_FAILURE:
      return state.set('updateArrangedOverdraftAlertError', fromJS(action.error));

    case CLOSE_MODAL:
      return state.set('updateArrangedOverdraftAlertError', fromJS(action.updateOverdraftError));

    default:
      return state;
  }
};

export default arrangedOverdraft;
